import { jsx as _jsx } from "react/jsx-runtime";
import styled, { css } from 'styled-components';
import { COLORS, MEDIUM } from '../utils/styled';
function UnstyledLabel({ children, ...props }) {
    // biome-ignore lint/a11y/noLabelWithoutControl: Element will come outside
    return _jsx("label", { ...props, children: children });
}
const Label = styled(UnstyledLabel) `
    color: ${COLORS.White};
    display: block;
    font-size: 1rem;
    font-weight: ${MEDIUM};
    line-height: 0.875rem;
    letter-spacing: 0%;
    margin: 0 0 8px;
    transition: 200ms cubic-bezier(0, 0, 0.2, 1) 0ms;
    transition-property: color, transform;

    ${({ $wrap = false }) => !$wrap &&
    css `
            white-space: nowrap;
        `}
`;
export default Label;
